module.exports = __webpack_public_path__ + "static/background-0547e8dc117b00f63c37e9c2974c4471.png";